import React from 'react'
import { Button, Grid, Typography } from '@mui/material'
import { CategoryTitle } from 'components'
import { QuizCard } from 'components'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import { useNavigate } from 'react-router-dom'

export const TopCategoryQuiz = ({ title, quizes, categoryId , icon }) => {
    const navigate =  useNavigate()
    return (
        <Grid container spacing={3} sx={{ mt: { xs: 2, lg: 4, p: 2 } }}>
            <Grid item xs={12} lg={3} sx={{mt:1}}>
                <CategoryTitle
                    Icon={icon}
                    title={title} />

                <Typography fontWeight={'regular'} sx={{ display: { xs: 'none', lg: 'block' }, mt: 2.5 }} fontSize={{ xs: 10, lg: 13 }} color='GrayText' >همین الان یادگیری رو شروع کن ،مسیر موفقیت رو طی کن</Typography>

                <Button onClick={()=>navigate(`/quizes/${categoryId}`)} sx={{ flex: { xs: 1, md: 'none' }, display:{xs:'none',lg:'flex'}  , mt :4 ,fontSize: { xs: 15, md: 'none' }  }} color='primary' variant='contained' endIcon={<ArrowBackIcon />} >
                   همه آزمون ها
                </Button>
            </Grid>
            {quizes.map(quiz => 
                <Grid item xs={12} lg={3}>
                    <QuizCard 
                        key={quiz.id} 
                        img = {quiz.titleImage}
                        title = {quiz.title}
                        caption = {quiz.description} 
                        teacherName = {quiz.creator.fullName} 
                        teacherPhoto = {quiz.titleImage}
                        length = {parseInt(quiz.time)} 
                        price = {quiz.priceExam} 
                        id = {quiz.id } 
                    />
                </Grid>)}
        </Grid>
    )
}
